import { FC } from 'react';
import { Wrapper } from './Sidebar.styled';

const Sidebar: FC = ({ children }) => (
  <Wrapper id="sidebar">{children}</Wrapper>
);

export { Sidebar };
